'use client';

import { Box } from '@enlighten/design-system';

import { useIframeAutoHeight } from '../_hooks/useIframeAutoHeight';

export default function Page() {
	const { iframeRef, height } = useIframeAutoHeight();

	return (
		<Box
			component="iframe"
			ref={iframeRef}
			src="/insurance-egi.html"
			sx={{
				height,
				minHeight: '100vh',
				padding: 0,
				width: '100%',
				border: 0,
			}}
		/>
	);
}
